export default "__VITE_ASSET__qjLvI6la__"